import { render, staticRenderFns } from "./subtranserlist.vue?vue&type=template&id=587c59fa"
import script from "./subtranserlist.vue?vue&type=script&lang=js"
export * from "./subtranserlist.vue?vue&type=script&lang=js"
import style0 from "./subtranserlist.vue?vue&type=style&index=0&id=587c59fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports